import React from 'react';
import { motion } from 'framer-motion';
import { MicroscopeIcon, ZapIcon, ActivityIcon, HeartPulseIcon, ShieldCheckIcon } from 'lucide-react';
export function ScienceSection() {
  const scienceCards = [{
    icon: MicroscopeIcon,
    title: 'Photobiomodulation',
    desc: 'The process where specific wavelengths of light interact with tissue to stimulate cellular processes, much like photosynthesis in plants.'
  }, {
    icon: ZapIcon,
    title: 'Mitochondria & ATP',
    desc: "Laser energy targets the mitochondria (the cell's powerhouse) to stimulate cytochrome c oxidase, boosting the production of ATP (cellular energy)."
  }, {
    icon: ActivityIcon,
    title: 'Cellular Signaling',
    desc: 'Increased ATP production triggers a cascade of beneficial cellular signals that promote healing and reduce inflammatory markers.'
  }, {
    icon: HeartPulseIcon,
    title: 'Circulation Support',
    desc: 'Therapy promotes vasodilation and angiogenesis (formation of new capillaries), increasing blood flow to damaged tissues.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Tissue Repair',
    desc: "Enhanced cellular energy and circulation accelerate the body's natural tissue repair and regeneration processes."
  }];
  return <section className="py-20 md:py-28 bg-brand-gray-light" data-id="element-164">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-166">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6" data-id="element-167">
            The Science Behind the Light
          </h2>
          <p className="text-lg text-gray-600" data-id="element-168">
            Class IV laser therapy is grounded in decades of clinical research
            and photobiology. Here is how the technology interacts with your
            body at a cellular level.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-169">
          {scienceCards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-170">
              <div className="flex items-center gap-4 mb-4" data-id="element-171">
                <div className="w-10 h-10 bg-brand-navy/5 rounded-lg flex items-center justify-center text-brand-navy" data-id="element-172">
                  <card.icon className="w-5 h-5" data-id="element-173" />
                </div>
                <h3 className="text-lg font-bold text-brand-navy" data-id="element-174">
                  {card.title}
                </h3>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-175">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="bg-white border-l-4 border-brand-teal p-6 md:p-8 rounded-r-xl shadow-sm max-w-4xl mx-auto" data-id="element-176">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-6" data-id="element-177">
            <div className="w-16 h-16 bg-brand-gray-light rounded-full flex items-center justify-center flex-shrink-0" data-id="element-178">
              <ShieldCheckIcon className="w-8 h-8 text-brand-teal" data-id="element-179" />
            </div>
            <div data-id="element-180">
              <h4 className="text-lg font-bold text-brand-navy mb-2 text-center md:text-left" data-id="element-181">
                FDA-Cleared Technology
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed text-center md:text-left" data-id="element-182">
                Our Class IV laser technology is FDA-cleared for the relief of
                minor muscle and joint pain, muscle spasm, pain and stiffness
                associated with minor arthritis, promoting relaxation of muscle
                tissue, and increasing local blood circulation.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}